// Pins the shared attention panel under the top-strip bell in docked mode.
import { useEffect, useState } from "react";
import type { CSSProperties } from "react";

const PANEL_WIDTH_PX = 380;

const BELL_PANEL_FALLBACK: CSSProperties = {
  position: "fixed",
  top: 56,
  right: 12,
  width: PANEL_WIDTH_PX,
  maxHeight: "calc(100vh - 96px)",
  zIndex: 9150,
};

export function useBellHostPanelStyle(enabled: boolean): CSSProperties | null {
  const [style, setStyle] = useState<CSSProperties | null>(enabled ? BELL_PANEL_FALLBACK : null);

  useEffect(() => {
    if (!enabled || typeof document === "undefined") return;
    const update = () => {
      const bell = document.querySelector<HTMLElement>("[data-attention-bell]");
      const top = bell ? bell.getBoundingClientRect().bottom + 8 : 56;
      setStyle({
        position: "fixed",
        top,
        right: 12,
        width: PANEL_WIDTH_PX,
        maxHeight: "calc(100vh - 96px)",
        zIndex: 9150,
      });
    };
    update();
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update, true);
    };
  }, [enabled]);

  return enabled ? (style ?? BELL_PANEL_FALLBACK) : null;
}
